import colors from "../../../theme/colors";

export default function PencilIcon({ size }: { size?: string }) {
  return (
    <svg
      style={{
        cursor: "pointer",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
      width={size || "12"}
      height={size || "12"}
      viewBox="0 0 19 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.339 3.9812L8.51164 13.14L5.83522 10.3631L14.6626 1.20428C14.6813 1.19828 14.7022 1.19194 14.7252 1.18548C14.8538 1.14933 15.039 1.11177 15.2565 1.10866C15.6768 1.10265 16.2335 1.22204 16.7777 1.78668C17.3219 2.35132 17.4369 2.92893 17.4311 3.36497C17.4281 3.59059 17.3919 3.78278 17.3571 3.91621C17.3509 3.94006 17.3448 3.96178 17.339 3.9812ZM17.3012 4.09267L17.302 4.09071C17.3012 4.09279 17.3009 4.09346 17.3012 4.09267Z"
        stroke={colors.placeholder}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M6.54156 10.7179L7.07613 10.1825L7.00822 10.1128L6.92459 10.0635L6.54156 10.7179ZM8.42277 12.6487L9.16409 12.7092L9.19784 12.3602L8.95734 12.1134L8.42277 12.6487ZM1.06522 15.2589L1.09423 16.0128L1.09423 16.0128L1.06522 15.2589ZM1.05573 15.2983L1.36954 14.6079L1.05573 15.2983ZM6.92459 10.0635C6.49495 9.81013 5.76137 9.59055 5.00903 9.90085C4.21621 10.2279 3.66035 11.0319 3.40298 12.2862L4.86132 12.5684C5.0623 11.5889 5.40506 11.3577 5.54933 11.2982C5.73406 11.222 5.97602 11.2647 6.15854 11.3723L6.92459 10.0635ZM3.40298 12.2862C3.05289 13.9924 1.71571 14.466 1.03621 14.5051L1.09423 16.0128C2.19869 15.9493 4.32488 15.1829 4.86132 12.5684L3.40298 12.2862ZM0.741922 15.9886C1.96073 16.5405 3.8417 17.0871 5.53682 16.8387C6.40166 16.712 7.2605 16.3712 7.9369 15.6746C8.6163 14.9749 9.04027 13.9897 9.16409 12.7092L7.68145 12.5883C7.58302 13.6062 7.26518 14.2328 6.88432 14.625C6.50048 15.0204 5.98063 15.2517 5.34946 15.3442C4.05256 15.5342 2.47227 15.1072 1.36954 14.6079L0.741922 15.9886ZM8.95734 12.1134L7.07613 10.1825L6.007 11.2533L7.88821 13.1841L8.95734 12.1134ZM1.03621 14.5051C0.649198 14.5273 0.394007 14.8175 0.323013 15.1044C0.249104 15.4031 0.353307 15.8127 0.741922 15.9886L1.36954 14.6079C1.73894 14.7752 1.83731 15.1657 1.76765 15.4472C1.70091 15.7169 1.46007 15.9917 1.09423 16.0128L1.03621 14.5051Z"
        fill={colors.placeholder}
      />
    </svg>
  );
}
